<template>
  <div class="wrap">
    <Nav :title="$t('newAdd.recharge')" fixed safeAreaInsetTop placeholder>
      <template #right>
        <div class="right_btn" @click="$router.push('/recharge-list')">
          {{ $t("newAdd.record") }}
        </div>
      </template>
    </Nav>
    <div class="content">
      <div class="userinfo">
        <div class="info_item">
          <div class="label">{{ $t('newAdd.account') }}</div>
          <div class="value">{{ userInfo.userphone }}</div>
        </div>
        <div class="info_item">
          <div class="label">{{ $t('newAdd.amount') }}</div>
          <van-field class="number" v-model="number" type="number" label-width="0"
            :placeholder="$t('newAdd.rechargeAmountPlaceholder')" />
        </div>
      </div>
      <div class="money_list">
        <div class="_list" :class="number == item ? 'active' : ''" v-for="item, index in countList" :key="index" @click="addClass(item)">
          {{ item }}
        </div>
      </div>
      <div class="recharge" v-if="bankList.length">
        <div class="title">{{ $t("newAdd.selectRechargeMethod") }}</div>
        <div class="recharge_list">
          <div class="list" v-for="item, index in bankList" :key="index" @click="paySubmit(item)">
            <div class="left">
              <div class="bank_title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
            <van-icon name="arrow" size="16" color="#999" />
          </div>
        </div>
      </div>
    </div>

    <!-- <van-tabs v-model="active" swipeable class="tabs" line-height="2px" line-width="15px">
      <van-tab v-for="item in tabPages" :key="item.type">
        <span slot="title">{{ item.title }}</span>
        <div v-if="item.lists.length > 0">
          <div class="mode" v-for="value in item.lists" :key="value.id" @click="paySubmit(value)">
            <img v-if="item.type !== 'idpay'" class="step-image"
              :src="require(`@/assets/images/user_pay/${item.type}.png`)" />
            <div class="step">
              <h5>{{ value.title }}</h5>
              <div class="desc_wrap">
                <p>{{ value.desc }}</p>
                <img :src="require('@/assets/icon/enter.png')" alt="" />
              </div>
            </div>
            <img v-if="value.letter == 1" class="tabbar-letter" :src="require('@/assets/images/user_pay/letter.png')" />
          </div>
        </div>
        <div v-else class="tips">
          {{ $t("newAdd.HaveNoteMethod") }}
        </div>
      </van-tab>
    </van-tabs> -->
  </div>
</template>

<script>
import { GET_RECHARGE_LIST, RECHARGE_COMMIT } from "@/api";
import Tabbar from "@/components/Tabbar";
import verConfig from "@/utils/verConfig";
import Nav from "@/components/Navbar";
import { icon, field, Dialog, Toast } from "vant";
import { mapGetters } from 'vuex';

export default {
  components: {
    [icon.name]: icon,
    [field.name]: field,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    Tabbar,
    Nav
  },
  data() {
    return {
      verConfig,
      countList: [
        "100",
        "200",
        "500",
        "1000",
        "5000",
        "10000",
        "30000",
        "50000",
      ],
      number: "",
      active: 0,
      tabPages: [],
      showTutorial: false,
      count: 1,
      bankList: []
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.getRechargeList();
    this.$store.dispatch('getUserInfo')
    this.$cookie.remove("qrPayData");
  },
  methods: {
    getRechargeList() {
      GET_RECHARGE_LIST().then(res => {
        const bankData = res.data;
        let arr = [];
        bankData.forEach(item => {
          if (item.lists.length) {
            arr = [...arr, ...item.lists]
          }
        })
        this.bankList = arr
      }).catch((e) => { });
    },
    addClass(item) {
      if (this.number == item) {
        return this.number = ''
      }
      this.number = item
    },
    paySubmit(item) {
      if (!this.number) return Toast(this.$t('newAdd.rechargeAmountPlaceholder'));
      RECHARGE_COMMIT({
        id: item.id,
        money: this.number,
      }).then((r) => {
        if (r.ret == 1) {
          if (r.data.bank.indexOf("qrcode") != -1) {
            r.data.step = item.step;
            r.data.id = item.id;
            this.$router.push({
              name: "qrPay",
              params: {
                payData: r.data,
              },
            });
          }
        } else if (r.ret === 2) {
          window.location.href = r.data.url;
        } else if (r.ret === 3) {
          if (r.data.bank.indexOf("bank-BANK") != -1) {
            r.data.step = item.step;
            r.data.id = item.id;
            this.$router.push({
              name: "bankPay",
              params: {
                payData: r.data,
              },
            });
          }
        } else {
          Toast(r.msg);
        }
      }).catch(err => { });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: var(--bgImg) no-repeat;
  background-size: 100% 100%;

  .right_btn {
    padding: calc(6rem / 16) calc(12rem / 16);
    font-size: calc(14rem / 16);
    background-color: var(--white);
    color: var(--black);
    border-radius: calc(4rem / 16);
  }

  .content {
    padding: calc(16rem / 16);

    .userinfo {
      background-color: var(--white);
      border-radius: calc(8rem / 16);

      .info_item {
        display: flex;
        align-items: center;
        column-gap: calc(16rem / 16);
        padding: calc(12rem / 16) calc(10rem /16);
        border-bottom: 1px dashed silver;

        .label {
          font-size: calc(14rem / 16);
          color: #000;
        }

        .value {
          flex: 1;
          text-align: right;
          color: #333;
          font-size: calc(14rem / 16);
        }

        .number {
          padding: 0;

          /deep/ .van-field__control {
            text-align: center;
          }
        }
      }

      .info_item:last-child {
        border-bottom-width: 0;
      }
    }

    .money_list {
      display: flex;
      flex-wrap: wrap;
      gap: calc(10rem / 16);
      padding: calc(20rem / 16) 0;

      ._list {
        width: calc((100% - 46rem / 16) / 4);
        padding: calc(12rem / 16) 0;
        text-align: center;
        border: 2px solid var(--white);
        color: var(--white);
        border-radius: calc(4rem / 16);
        font-size: calc(14rem / 16);
      }

      .active {
        background: var(--btnColor);
        border-color: transparent;
      }
    }

    .recharge {
      background: var(--white);
      padding: calc(12rem / 16) calc(10rem / 16);
      border-radius: calc(4rem / 16);
      .title {
        border-radius: calc(4rem / 16);
        font-size: calc(16rem / 16);
        color: #333;
      }

      .recharge_list {
        .list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: calc(12rem / 16) 0;
          border-bottom: 1px dashed silver;

          .left {
            .bank_title {
              font-size: calc(14rem / 16);
              color: var(--theme);
            }

            .desc {
              color: #999;
              margin-top: calc(8rem / 16);
              font-size: calc(12rem / 16);
            }
          }
        }
        .list:last-child{
          border-bottom: none;
        }
      }
    }
  }
}
</style>
